/* KBW Quick Order — the whole lower screen's behaviour.

   Filtering is Shopify's, not ours. The rail, the tabs and the page links are
   all real URLs printed by Liquid from the collection's own filters, so the
   counts and the results describe the whole category rather than the hundred
   products that happen to be loaded. A rail built from the page could not do
   that: asking it for every corner cabinet returned the corners on page one
   and quietly dropped the rest.

   What this file does is keep that from costing a page load. Clicking a facet,
   a tab or a page number fetches this section alone and swaps its markup in,
   pushing the new URL so the address bar, the back button and a shared link all
   stay honest.

   Sorting and collapsing stay here, because reordering or folding what is shown
   claims nothing about what is not.

   With no script: every row shows, each with its own price and its own add
   button, and the cart forms still post. Wordier, but correct.

   Markup contract:
     [data-kbw-qo]              section root
     [data-kbw-qo-row]          a row; data-group / data-alt / data-side /
                                data-variant / data-price / data-price-text /
                                data-sku / data-url / data-img / data-w /
                                data-wt / data-hd / data-dims / data-feat
     [data-kbw-qo-group]        a group, data-name
     [data-kbw-qo-facets]       where the rail's groups are written (the rail
                                itself: assets/kbw-filter-rail.js)
     [data-kbw-qo-draw]         the drawing panel of a group
*/

(function () {
  'use strict';

  var SIRA = ['Unfinished', 'Left Side', 'Right Side', 'Both Sides'];
  var ETIKET = {
    'Unfinished': 'No finished end',
    'Left Side': 'Left finished',
    'Right Side': 'Right finished',
    'Both Sides': 'Both finished',
  };

  function para(ornek, kurus) {
    /* The rows carry prices already formatted by Liquid, which knows the shop's
       currency. Only the symbol is borrowed so an upcharge reads the same. */
    var sembol = (ornek.match(/^[^\d]*/) || [''])[0];
    return sembol + (kurus / 100).toFixed(2);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* The rail and the drawing stick under the header, and this theme's header
     hides itself on the way down and comes back on the way up. A fixed offset
     is therefore wrong half the time — too big while scrolling down, leaving a
     band of empty page above the filters. The header's own bottom edge is read
     instead, so the gap is whatever the header is actually occupying: nought
     when it has gone, its height when it is back.

     Set once on the page rather than per section — everything that sticks in
     this screen wants the same number. */
  var basliksiz = false;
  function ustBosluk() {
    if (basliksiz) return;
    var h = document.querySelector('.section-header') || document.querySelector('header');
    if (!h) { basliksiz = true; return; }
    var alt = h.getBoundingClientRect().bottom;
    if (alt < 0) alt = 0;
    document.documentElement.style.setProperty('--kbw-qo-top', Math.round(alt) + 'px');
  }

  /* The floating cart is out for the whole page except the very top, where the
     header's own is right there and a second one would be noise.

     It also has to share the corner with the theme's back-to-top button, which
     comes and goes on its own schedule: when that button is out the cart sits
     above it, and when it is not the cart takes the spot. Both read off the
     button itself rather than a guessed number, so a change to the theme's
     offset setting carries here. */
  /* Mirrors the header's badge instead of counting for itself. The theme
     re-renders that badge on every cart change, whatever caused it — adding
     here, removing in the drawer, editing on the cart page — so reading it is
     the only way to stay right without guessing at every path. */
  function sepetSayaci() {
    var rozet = document.querySelector('[data-kbw-qo-cartcount]');
    if (!rozet) return;
    var kaynak = document.querySelector('#cart-icon-bubble [data-count-item]');
    var n = kaynak ? parseInt(kaynak.getAttribute('data-count-item'), 10) || 0 : 0;
    rozet.textContent = n;
    rozet.hidden = n === 0;
  }

  /* The theme swaps the badge's markup and then announces it; the announcement
     can land a tick before the swap, so it is read again shortly after. */
  document.addEventListener('maximize:cart:updated', function () {
    sepetSayaci();
    setTimeout(sepetSayaci, 400);
  });

  /* The assembly line's own repair (kbw-cart-assembly.js) changes the cart
     AFTER the theme's announcement above — removing a cabinet takes its
     assembly line with it a moment later — and repaints the header badge
     without announcing it to the theme. It announces it here instead. The
     badge is already repainted when this fires, so one read is enough. */
  document.addEventListener('kbw:cart:reconciled', sepetSayaci);

  function sepetKisayolu() {
    var dugme = document.querySelector('[data-kbw-qo-cart]');
    if (!dugme) return;
    sepetSayaci();

    dugme.hidden = window.scrollY < 200;

    var yukari = document.querySelector('.scroll-to-top__button');
    var alt = 20;
    if (yukari) {
      var cs = getComputedStyle(yukari);
      var kendiAlt = parseFloat(cs.bottom) || 20;
      var b = yukari.getBoundingClientRect();
      var gorunur = b.height > 0 && cs.visibility !== 'hidden' && cs.opacity !== '0';
      alt = gorunur ? kendiAlt + b.height + 12 : kendiAlt;
    }
    document.documentElement.style.setProperty('--kbw-qo-cart-bottom', Math.round(alt) + 'px');
  }

  var bekliyor = false;
  var gecikme;
  function ustBoslukPlanla() {
    if (!bekliyor) {
      bekliyor = true;
      requestAnimationFrame(function () { bekliyor = false; ustBosluk(); sepetKisayolu(); });
    }
    /* The back-to-top button fades in over half a second, so the first reading
       after it appears catches it mid-transition and the two briefly overlap.
       One more look once the movement has stopped. */
    clearTimeout(gecikme);
    gecikme = setTimeout(sepetKisayolu, 560);
  }

  function setup(root) {
    if (root.dataset.kbwQoReady === '1') return;
    root.dataset.kbwQoReady = '1';

    ustBosluk();
    sepetKisayolu();
    window.addEventListener('scroll', ustBoslukPlanla, { passive: true });
    window.addEventListener('resize', ustBoslukPlanla, { passive: true });

    var rows = [].slice.call(root.querySelectorAll('[data-kbw-qo-row]'));
    if (!rows.length) return;

    var gruplar = [].slice.call(root.querySelectorAll('[data-kbw-qo-group]'));
    var listeEl = root.querySelector('[data-kbw-qo-list]');
    var bosEl = root.querySelector('[data-kbw-qo-empty]');
    var satirSayac = root.querySelector('[data-kbw-qo-rowcount]');
    var grupSayac = root.querySelector('[data-kbw-qo-groupcount]');
    var siraEl = root.querySelector('[data-kbw-qo-sort]');
    var katlaEl = root.querySelector('[data-kbw-qo-collapse]');

    var sira = 'size';

    /* Rows are what the server sent; nothing here decides which of them count.
       The only thing left to do on load is order them and total the groups. */

    function uygula() {
      var toplamSatir = 0;
      var acikGrup = 0;

      gruplar.forEach(function (g) {
        var kalan = [].slice.call(g.querySelectorAll('[data-kbw-qo-row]:not([data-alt])'));
        if (!kalan.length) { g.hidden = true; return; }
        g.hidden = false;
        acikGrup++;
        toplamSatir += kalan.length;
        sirala(g, kalan);
      });

      if (satirSayac) satirSayac.textContent = toplamSatir;
      if (grupSayac) grupSayac.textContent = acikGrup;
      if (bosEl) bosEl.hidden = acikGrup > 0;
      if (listeEl) listeEl.hidden = acikGrup === 0;
    }

    /* --- Sorting ----------------------------------------------------------
       Rows move inside their own group; group order is what Liquid printed. A
       cabinet's finish records follow it so the chooser keeps working. */

    function sirala(g, kalan) {
      var tablo = g.querySelector('.kbw-qo__table');
      if (!tablo) return;

      var sirali = kalan.slice();
      if (sira === 'priceAsc') sirali.sort(function (a, b) { return a.getAttribute('data-price') - b.getAttribute('data-price'); });
      else if (sira === 'priceDesc') sirali.sort(function (a, b) { return b.getAttribute('data-price') - a.getAttribute('data-price'); });
      else if (sira === 'model') sirali.sort(function (a, b) { return (a.getAttribute('data-sku') || '').localeCompare(b.getAttribute('data-sku') || ''); });
      else sirali.sort(function (a, b) { return parseFloat(a.getAttribute('data-w')) - parseFloat(b.getAttribute('data-w')); });

      sirali.forEach(function (r) {
        tablo.appendChild(r);
        var k = r.getAttribute('data-group');
        [].slice.call(g.querySelectorAll('[data-kbw-qo-row][data-alt]')).forEach(function (x) {
          if (x.getAttribute('data-group') === k) tablo.appendChild(x);
        });
      });
    }

    /* --- The finish chooser ------------------------------------------------ */

    function cilaKur() {
      var kume = {};
      rows.forEach(function (r) {
        var k = r.getAttribute('data-group');
        if (!k) return;
        (kume[k] || (kume[k] = [])).push(r);
      });

      Object.keys(kume).forEach(function (k) {
        var uyeler = kume[k];
        var birincil = uyeler.filter(function (r) { return !r.hasAttribute('data-alt'); })[0] || uyeler[0];
        adet(birincil);
        if (uyeler.length < 2) return;

        uyeler.sort(function (a, b) {
          return SIRA.indexOf(a.getAttribute('data-side')) - SIRA.indexOf(b.getAttribute('data-side'));
        });

        var yuva = birincil.querySelector('[data-kbw-qo-finish]');
        if (!yuva) return;
        var taban = parseInt(birincil.getAttribute('data-price'), 10) || 0;
        var ornek = birincil.getAttribute('data-price-text') || '';

        var sec = document.createElement('select');
        sec.className = 'kbw-qo__fin-select';
        sec.setAttribute('aria-label', 'Finished end');

        uyeler.forEach(function (r, i) {
          var yuz = r.getAttribute('data-side');
          var fark = (parseInt(r.getAttribute('data-price'), 10) || 0) - taban;
          var o = document.createElement('option');
          o.value = String(i);
          o.textContent = (ETIKET[yuz] || yuz) + (fark > 0 ? ' +' + para(ornek, fark) : '');
          sec.appendChild(o);
        });

        sec.addEventListener('change', function () {
          var r = uyeler[Number(sec.value)] || birincil;
          /* Anything but the cheapest is an upcharge, and an upcharge that
             looks like every other control is an upcharge nobody notices. */
          sec.classList.toggle('is-upgraded', Number(sec.value) !== 0);

          var f = birincil.querySelector('[data-kbw-qo-price]');
          if (f) f.textContent = r.getAttribute('data-price-text') || '';
          var idEl = birincil.querySelector('[data-kbw-qo-id]');
          if (idEl) idEl.value = r.getAttribute('data-variant') || '';
          var kod = birincil.querySelector('.kbw-qo__code');
          if (kod) {
            kod.textContent = r.getAttribute('data-sku') || 'View';
            kod.setAttribute('href', r.getAttribute('data-url') || kod.getAttribute('href'));
          }
        });

        yuva.textContent = '';
        yuva.appendChild(sec);
      });
    }

    function adet(row) {
      var input = row.querySelector('[data-kbw-qo-qty]');
      if (!input) return;
      var eksi = row.querySelector('[data-kbw-qo-minus]');
      var arti = row.querySelector('[data-kbw-qo-plus]');
      function degistir(n) {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = 1;
        v += n;
        input.value = v < 1 ? 1 : v;
      }
      if (eksi) eksi.addEventListener('click', function () { degistir(-1); });
      if (arti) arti.addEventListener('click', function () { degistir(1); });
    }

    /* --- The drawing follows the selection --------------------------------- */

    function cizimKur() {
      gruplar.forEach(function (g) {
        var panel = g.querySelector('[data-kbw-qo-draw]');
        if (!panel) return;

        function gec(r) {
          [].slice.call(g.querySelectorAll('[data-kbw-qo-row]')).forEach(function (x) {
            x.classList.toggle('is-selected', x === r);
          });
          var img = panel.querySelector('[data-kbw-qo-drawimg]');
          if (img && r.getAttribute('data-img')) img.src = r.getAttribute('data-img');
          var set = function (sel, val) {
            var n = panel.querySelector(sel);
            if (!n) return;
            n.textContent = val || '';
            /* A tick, a rule and an empty label is a measurement of nothing.
               Kits and light bars carry no dimensions, so the callout goes
               rather than pointing at a size that was never recorded. */
            var cizgi = n.closest('.kbw-qo__callout');
            if (cizgi) cizgi.hidden = !val;
          };
          set('[data-kbw-qo-cw]', r.getAttribute('data-wt'));
          set('[data-kbw-qo-ch]', (r.getAttribute('data-hd') || '').split(' × ')[0]);
          set('[data-kbw-qo-drawdims]', r.getAttribute('data-dims'));
          set('[data-kbw-qo-drawcode]', r.getAttribute('data-sku'));
          panel.dataset.url = r.getAttribute('data-img') || '';
          panel.dataset.title = g.querySelector('.kbw-qo__group-title').textContent.trim();
          panel.dataset.sub = [r.getAttribute('data-sku'), r.getAttribute('data-dims')].filter(Boolean).join(' · ');
        }

        [].slice.call(g.querySelectorAll('[data-kbw-qo-row]:not([data-alt])')).forEach(function (r) {
          r.addEventListener('click', function (e) {
            /* A row is a selector and a container of controls at once; clicking
               a control must not also re-point the drawing. */
            if (e.target.closest('button, a, input, select')) return;
            gec(r);
          });
        });

        var ilk = g.querySelector('[data-kbw-qo-row]:not([data-alt])');
        if (ilk) gec(ilk);
      });
    }

    /* --- Enlarge ----------------------------------------------------------- */

    var zoomLayer = root.querySelector('[data-kbw-qo-zoomlayer]');
    if (zoomLayer) {
      var zImg = zoomLayer.querySelector('[data-kbw-qo-zoomimg]');
      var zTitle = zoomLayer.querySelector('[data-kbw-qo-zoomtitle]');
      var zSub = zoomLayer.querySelector('[data-kbw-qo-zoomsub]');

      function zoomKapat() { zoomLayer.hidden = true; document.body.style.overflow = ''; }

      root.querySelectorAll('[data-kbw-qo-zoom]').forEach(function (b) {
        b.addEventListener('click', function () {
          var panel = b.closest('[data-kbw-qo-draw]');
          if (!panel) return;
          zImg.src = panel.dataset.url || '';
          zImg.alt = panel.dataset.title || '';
          zTitle.textContent = panel.dataset.title || '';
          zSub.textContent = panel.dataset.sub || '';
          zoomLayer.hidden = false;
          document.body.style.overflow = 'hidden';
        });
      });

      zoomLayer.addEventListener('click', function (e) {
        if (e.target === zoomLayer || e.target.closest('[data-kbw-qo-zoomclose]')) zoomKapat();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zoomKapat(); });
    }

    /* --- Toast and multi-add ----------------------------------------------- */

    var toastEl = root.querySelector('[data-kbw-qo-toast]');
    var toastText = root.querySelector('[data-kbw-qo-toasttext]');
    var toastTimer;

    function toast(msg) {
      if (!toastEl) return;
      clearTimeout(toastTimer);
      toastText.textContent = msg;
      toastEl.hidden = false;
      toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2200);
    }

    /* The theme owns the cart icon, its badge and the drawer, and it repaints
       them by asking Shopify to re-render those sections alongside the add.
       Posting to /cart/add.js on our own added the item but left the badge
       showing yesterday's count until a reload — so the theme's own helper does
       the adding, and we only say what happened. */
    /* Adding from a list of forty sizes is not the same gesture as adding from
       a product page: the customer is still choosing, and a drawer sliding out
       every time has to be dismissed before the next one can be picked. So the
       theme's own section-rerender is reused — that is what moves the cart
       badge — but the event that opens the drawer is not sent. */
    function sepeteYolla(kalemler, msg) {
      var kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var yardimci = window.xCartHelper;
      var drawer = document.querySelector('#CartDrawer');
      var bolumler = [];

      if (yardimci && typeof yardimci.getSectionsToRender === 'function') {
        bolumler = yardimci.getSectionsToRender(drawer && drawer.dataset.sectionId) || [];
      }

      return fetch(kok + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: kalemler, sections: bolumler.map(function (s) { return s.id; }) }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cevap) {
          if (cevap.status && cevap.status !== 200) throw new Error(cevap.description || 'cart');

          /* The cart icon, its badge and the drawer's contents are all sections
             Shopify just re-rendered for us; swapping their markup is how the
             count moves without a reload. */
          bolumler.forEach(function (s) {
            var el = document.querySelector(s.selector);
            var html = cevap.sections && cevap.sections[s.id];
            if (!el || !html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var kaynak = doc.querySelector(s.selector) || doc.body;
            el.innerHTML = kaynak.innerHTML;
          });

          if (yardimci && typeof yardimci.updateCurrentCountItem === 'function') {
            yardimci.updateCurrentCountItem();
          }
          /* `openMiniCart` is deliberately absent. */
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { isItemCountChanged: true },
          }));
          toast(msg);

          sepetSayaci();
          setTimeout(sepetSayaci, 400);
        });
    }

    /* KBW: assembly option. The tick adds a SECOND line to the cart — the fee
       variant, at the cabinet's own quantity, carrying the cabinet's name — and
       the cabinet's own line is untouched. `kbw-assembly.js` owns that rule and
       hands the lines over; this file only posts them.

       The no-script fallback (`form.submit()`) posts the cabinet alone, which
       is why the tick is hidden until the script is up: a control that cannot
       keep its promise is not drawn. */
    function asmExtra(el, q) {
      if (!window.KbwAssembly) return [];
      return window.KbwAssembly.extra(el, q);
    }

    root.querySelectorAll('[data-kbw-qo-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = form.querySelector('[data-kbw-qo-id]').value;
        var q = parseInt(form.querySelector('[data-kbw-qo-qty]').value, 10) || 1;
        /* The surcharge goes into the payload BEFORE its cabinet. Measured on
           the store: the cart lists the most recently added line first, so the
           line sent last is the line drawn highest — and the design wants the
           cabinet on top with its surcharge indented underneath it. Sent the
           other way round the surcharge appears above the cabinet and reads as
           belonging to whatever is above THAT.

           This is observed behaviour, not a documented guarantee, which is why
           the surcharge also says which cabinet it is for in words. If Shopify
           ever flips the order the pair looks wrong; it never reads wrong. */
        var kalemler = asmExtra(form, q).concat([{ id: id, quantity: q }]);
        sepeteYolla(kalemler, q + (q === 1 ? ' item added' : ' items added'))
          .catch(function () { form.submit(); });
      });
    });

    root.querySelectorAll('[data-kbw-qo-addall]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.closest('[data-kbw-qo-group]');
        var kalemler = [];
        [].slice.call(g.querySelectorAll('[data-kbw-qo-row]:not([data-alt])')).forEach(function (r) {
          if (r.hidden) return;
          var qtyEl = r.querySelector('[data-kbw-qo-qty]');
          var idEl = r.querySelector('[data-kbw-qo-id]');
          if (!qtyEl || !idEl) return; /* a zero-priced row has no form at all */
          var q = parseInt(qtyEl.value, 10) || 0;
          if (q > 0 && r.classList.contains('is-touched')) {
            /* KBW: assembly option — the row's own tick, row by row, and the
               surcharge before its cabinet for the reason given above. */
            kalemler = kalemler.concat(asmExtra(r, q));
            kalemler.push({ id: idEl.value, quantity: q });
          }
        });
        if (!kalemler.length) { toast('Set a quantity on a size first'); return; }
        /* Counted off the rows rather than off the payload: an assembly line
           is not a cabinet, and "4 items added" for two cabinets built for you
           is a number the customer cannot reconcile with the list. */
        var toplam = 0;
        [].slice.call(g.querySelectorAll('[data-kbw-qo-row]:not([data-alt])')).forEach(function (r) {
          var qtyEl = r.querySelector('[data-kbw-qo-qty]');
          if (!qtyEl || r.hidden || !r.classList.contains('is-touched')) return;
          toplam += parseInt(qtyEl.value, 10) || 0;
        });
        sepeteYolla(kalemler, toplam + ' items added');
      });
    });

    /* "Add selected quantities" means the ones the customer touched, not every
       row sitting at its default of one. */
    root.querySelectorAll('[data-kbw-qo-qty]').forEach(function (i) {
      var mark = function () { i.closest('[data-kbw-qo-row]').classList.add('is-touched'); };
      i.addEventListener('input', mark);
      var row = i.closest('[data-kbw-qo-row]');
      row.querySelectorAll('[data-kbw-qo-minus], [data-kbw-qo-plus]').forEach(function (b) {
        b.addEventListener('click', mark);
      });
    });

    /* --- Toolbar ----------------------------------------------------------- */

    if (siraEl) siraEl.addEventListener('change', function () { sira = siraEl.value; uygula(); });

    if (katlaEl) {
      katlaEl.addEventListener('click', function () {
        var kapali = katlaEl.dataset.state === 'closed';
        gruplar.forEach(function (g) {
          var d = g.querySelector('details');
          if (d) d.open = kapali;
        });
        katlaEl.dataset.state = kapali ? 'open' : 'closed';
        katlaEl.textContent = kapali ? 'Collapse all groups' : 'Expand all groups';
      });
    }

    /* --- The rail as a drawer ---------------------------------------------
       KBW: the drawer, Show more and the sticky offset are the shared filter
       rail's (assets/kbw-filter-rail.js), the same on every list page. */

    /* --- Category tabs without a reload -------------------------------------
       A tab has to change which products are loaded — 460 wall cabinets do not
       fit in one page — so it cannot be answered from what is already here.
       Instead of handing the browser a new document, Shopify is asked to render
       just this section and its markup is swapped in. The URL is still updated,
       so a tab stays shareable and the back button still works. */

    (function () {
      var sectionId = root.getAttribute('data-section-id');
      var kutu = document.getElementById('shopify-section-' + sectionId);
      if (!sectionId || !kutu) return;

      function getir(url, push) {
        var ayrac = url.indexOf('?') >= 0 ? '&' : '?';
        root.classList.add('is-loading');

        fetch(url + ayrac + 'section_id=' + sectionId, { headers: { Accept: 'text/html' } })
          .then(function (r) {
            if (!r.ok) throw new Error('section');
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var yeni = doc.querySelector('[data-kbw-qo]');
            if (!yeni) throw new Error('empty');
            kutu.innerHTML = doc.body.innerHTML;
            if (push) history.pushState({ kbwQo: true }, '', url);
            /* The swapped markup is a fresh section that has never been set up;
               the guard flag came across in the HTML, so it is cleared. */
            var taze = kutu.querySelector('[data-kbw-qo]');
            if (taze) delete taze.dataset.kbwQoReady;
            setupAll();
            /* A drawer that was open over the old markup is put back open
               over the new one, and the new lists are clipped. */
            if (window.KbwRail) {
              window.KbwRail.refresh(kutu);
              window.KbwRail.sync();
            }
            /* Paging keeps you where the list is; switching tab starts over at
               the top of the section. */
            var hedef = url.indexOf('page=') >= 0
              ? (kutu.querySelector('[data-kbw-qo-list]') || kutu)
              : kutu;
            hedef.scrollIntoView({ block: 'start', behavior: 'smooth' });
          })
          .catch(function () {
            /* Anything unexpected and the browser does what it always did. */
            window.location.href = url;
          });
      }

      /* Facets, tabs and page links are all the same move — a different set of
         products from the server — so they take the same route. All stay real
         links, so a middle click, a right click and a crawler still get a URL. */
      var SECICI = '.kbw-qo__tab, a.kbw-qo__page, [data-kbw-qo-facets] a, .kbw-qo__pill,' +
        ' .kbw-rail__reset, .kbw-qo__empty-btn';
      root.querySelectorAll(SECICI).forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
          e.preventDefault();
          getir(a.getAttribute('href'), true);
        });
      });

      /* --- The tab the screen opens on ---------------------------------
         Landing on the bare collection URL used to mean the mixed list. The
         section marks itself `is-defaulting` in that case and names the tab it
         wants; one swap later the list agrees with the highlighted tab.

         replaceState, not pushState: the customer did not navigate here, so
         Back should leave the collection rather than undo a choice they never
         made. */
      (function () {
        var tab = root.getAttribute('data-default-tab');
        var param = root.getAttribute('data-default-param');
        var base = root.getAttribute('data-collection-url');
        if (!tab || !param || !base) return;
        var url = base + '?' + param + '=' + encodeURIComponent(tab);
        history.replaceState({ kbwQo: true }, '', url);
        getir(url, false);
      })();

      /* The price range is a form, so its URL is assembled from its own fields
         plus the hidden ones carrying every other active choice. */
      var fiyatFormu = root.querySelector('[data-kbw-qo-pricefilter]');
      if (fiyatFormu) {
        fiyatFormu.addEventListener('submit', function (e) {
          e.preventDefault();
          var q = new URLSearchParams(new FormData(fiyatFormu));
          getir(fiyatFormu.getAttribute('action') + '?' + q.toString(), true);
        });
      }

      window.addEventListener('popstate', function (e) {
        if (e.state && e.state.kbwQo) getir(location.pathname + location.search, false);
      });
    })();

    /* Clicking ours should do what clicking the header's does — open the
       drawer on the page you are on. The theme already owns that decision,
       including falling back to /cart when the drawer is switched off, so its
       own icon is clicked rather than the behaviour being copied. */
    var yuzenSepet = root.querySelector('[data-kbw-qo-cart]');
    if (yuzenSepet) {
      yuzenSepet.addEventListener('click', function (e) {
        var ikon = document.querySelector('#cart-icon');
        if (!ikon) return;
        e.preventDefault();
        ikon.click();
      });
    }

    cilaKur();
    cizimKur();
    uygula();
  }

  function setupAll() {
    var roots = document.querySelectorAll('[data-kbw-qo]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  // The theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', setupAll);
})();
